//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import { makeStyles } from '@material-ui/core/styles';

export const headerStyles = makeStyles((theme) => ({
  component: {
    display: 'flex',
    flexFlow: 'column',
    '@media (max-width: 768px)': {
      height: '100%',
    },
  },
  Link: {
    color: '#707070',
    textDecoration: 'none',
  },
  highLight: {
    backgroundColor: '#eaf2f8',
    color: '#2F7CBD',
    borderRadius: 10,
    '&:hover': {
      background: '#eaf2f8',
    },
  },
  icon: {
    color: '#2F7CBD',
  },
  ref: {
    textAlign: 'center',
    fontSize: '12px',
    padding: '0px 15px',
    cursor: 'pointer',
    fontWeight: 'bold',
    '@media (max-width: 768px)': {
      fontSize: 12,
    },
  },
  sideBarStyle: {
    fontFamily: 'Segoe-ui',
    fontSize: '0.875rem',
    color: '#000',
  },
  sideBarCustomTextSize: {
    whiteSpace: 'nowrap',
    fontWeight: 'bold',
    width: '170px',
    paddingLeft: 10,
  },
  backtoHendry: {
    textAlign: 'center',
    fontSize: '12px',
    cursor: 'pointer',
    fontWeight: 'bold',
    width: 70,
    lineHeight: 1.3,
    '@media (max-width: 768px)': {
      fontSize: 12,
    },
  },
  logoImgDiv: {
    marginLeft: '10px',
    marginTop: 5,
  },
  logoImg: {
    width: '30%',
    backgroundColor: '#fff',
    '@media (max-width: 768px)': {
      width: 150,
    },
  },
  grid: {
    textAlign: 'right',
    display: 'inline-block',
  },
  menuIconBtn: {
    padding: '0 18px',
    marginTop: 0,
    // only for IE 9 or IE 11 browsers.
    '@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none)':
      {
        width: '50px',
      },
    '@media (max-width: 600px)': {
      marginTop: 5,
    },
  },
  menuIcon: {
    color: '#4472c4',
    fontWeight: 'bold',
  },
  sidebarItemActive: {
    backgroundColor: '#a0d2fd ',
    color: '#305698',
  },
  listItem: {
    padding: '0px',
    margin: '3px 0',
    boxShadow: 'none',
  },
  adminSidebarList: {
    padding: '0px',
    margin: '3px 0',
    boxShadow: 'none',
    color: '#000',
  },
  globeIconBtn: {
    padding: '0px 15px',
  },
  languageIcon: {
    color: '#4472c4',
    fontWeight: 'bold',
    marginTop: 3,
    marginLeft: 5,
    '@media (max-width: 768px)': {
      fontSize: '30px',
      marginLeft: 0,
    },
  },
  flexGrid: {
    flex: 1,
    display: 'inline-block',
    float: 'right',
  },
  backToGrid: {
    display: 'inline-block',
    verticalAlign: 'top',
    float: 'right',
    '@media (max-width: 768px)': {
      width: 75,
    },
  },
  flexBoxDiv: {
    // only for IE 9 or IE 11 browsers.
    marginRight: 10,
    '@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none)':
      {
        marginLeft: '10%',
      },
  },
  gridContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: '#fff',
    padding: 5,
    '@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none)':
      {
        justifyContent: 'flex-start',
      },
  },
  hrTag: {
    display: 'block',
    height: '1px',
    border: 0,
    borderTop: '1px solid #707070',
    margin: ' 0',
    padding: 0,
  },
}));
